import { render, staticRenderFns } from "./PlanCancellation.vue?vue&type=template&id=5276215a&scoped=true&"
import script from "./PlanCancellation.vue?vue&type=script&lang=js&"
export * from "./PlanCancellation.vue?vue&type=script&lang=js&"
import style0 from "./PlanCancellation.vue?vue&type=style&index=0&id=5276215a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276215a",
  null
  
)

export default component.exports